import React from 'react';
import {FaBalanceScale} from "react-icons/fa";
import {FaPeopleRoof} from "react-icons/fa6";
import {TbBuildingEstate} from "react-icons/tb";
import {LuArrowRight} from 'react-icons/lu';
import {Link} from "react-router-dom";
import {Element, scroller} from 'react-scroll';
import {useInView} from 'react-intersection-observer';
import './Home.scss';
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ServiceCard from "../components/ServiceCard";
import BeforeAfterHero from '../components/BeforeAfterHero';
import TestimonialCarousel from "../components/TestimonialCarousel";
import logoSvg from "../assets/images/logos/logo_only_gray.svg"

function Home() {
    const scrollToBannerSection = () => {
        scroller.scrollTo('home-services', {
            duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -96,
        });
    };

    const {ref: bannerRef, inView: bannerInView} = useInView({triggerOnce: true, threshold: 0.2});
    const {ref: servicesRef, inView: servicesInView} = useInView({triggerOnce: true, threshold: 0.2});
    const {ref: contactRef, inView: contactInView} = useInView({triggerOnce: true, threshold: 0.2});
    const {ref: aboutRef, inView: aboutInView} = useInView({triggerOnce: true, threshold: 0.2});

    return (
        <>
            <div className="home-landing">
                <h1 className="visually-hidden">Arkham Law</h1>
                <BeforeAfterHero />
                <button className="scroll-downs" onClick={scrollToBannerSection} aria-label="Explore our services">
                    <span className="mousey" aria-hidden="true"><span className="scroller" /></span>
                </button>
            </div>

            <Element name="home-services"><div ref={servicesRef}
                 className={`home-services fade-in-section ${servicesInView ? 'animate-fade-up' : ''}`}>
                <div className="practice-card mx-auto">
                    <div className="practice-heading">
                        {/*<h2 className="semi-bold f-15 ak-blue mb-4">OUR SERVICES</h2>*/}
                        <h2 className="semi-bold f-35 ak-primary hero-title-h1 highlight-expert-text">
                            OUR SERVICES
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-4 text-start">
                            <ServiceCard
                                icon={<FaPeopleRoof size={50}/>}
                                title="Immigration"
                                description="Expert guidance through complex immigration processes for individuals and families"
                                serviceId="immigration"
                            />
                        </div>
                        <div className="col-sm-12 col-md-4 text-start">
                            <ServiceCard
                                icon={<TbBuildingEstate size={50}/>}
                                title="Residential Real Estate"
                                description="Comprehensive assistance with residential property transactions"
                                serviceId="residential"
                            />
                        </div>
                        <div className="col-sm-12 col-md-4 text-start">
                            <ServiceCard
                                icon={<FaBalanceScale size={50}/>}
                                title="Commercial Real Estate"
                                description="Providing strategic legal support in commercial property and business asset transactions."
                                serviceId="commercial"
                            />
                        </div>
                    </div>
                </div>
            </div></Element>

            <div ref={aboutRef} className={`home-about fade-in-section ${aboutInView ? 'animate-fade-up' : ''}`}>
                <Element name="home-about" style={{paddingTop: 60, marginBottom: 50}}>
                    <div className="home-services-card mx-auto">
                        <div className="row">
                            <div className="col-sm-12 col-md-5 mb-4">
                                {/*<h2 className="semi-bold f-15 ak-blue text-start">ABOUT US</h2>*/}
                                <h2 className="semi-bold f-35 ak-primary hero-title-h1 highlight-expert-text text-start">
                                    ABOUT US
                                </h2>
                            </div>
                            <div className="col-sm-12 col-md-7 text-start">
                                <p>
                                    At Arkham Law, we offer expert guidance in both residential and commercial real
                                    estate
                                    transactions,
                                    ensuring that you navigate the complexities of the property market with
                                    confidence.
                                </p>
                                <p>
                                    We also
                                    offer comprehensive immigration services to help individuals and families who seek
                                    to visit or
                                    immigrate to Canada.
                                </p>
                                <Link to="/about" className="ak-round-btn" style={{maxWidth: 170}}>
                                    Learn More <LuArrowRight aria-hidden="true"/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Element>
            </div>

            <div ref={contactRef} className={`home-contact fade-in-section ${contactInView ? 'animate-fade-up' : ''}`}>
                <img alt="" src={logoSvg} className={"home-svg"}/>
                <Element name="home-contact">
                    {/*<h2 className="semi-bold f-15 ak-blue home-welcome-h2">CONTACT US</h2>*/}
                    {/*<h1 className="semi-bold f-35 ak-primary hero-title-h1 highlight-expert-text">Professional &*/}
                    {/*    Personable</h1>*/}
                    <Contact/>
                </Element>
            </div>

            <div
                className="banner-wrapper glasses-banner"
                style={{
                    // backgroundImage: `url(${bannerBg})`,
                    backgroundColor: "#efefef",
                    backgroundSize: "cover",
                    backgroundPosition: "center calc(-150px)",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    minHeight: "380px", // Ensures it scales down properly
                    maxHeight: "none",
                    position: "relative",
                    display: "flex",
                    alignItems: "center", // Centers content vertically
                    justifyContent: "center", // Centers content horizontally
                }}
            >
                <div
                    ref={bannerRef}
                    className={`banner-content fade-in-section ${
                        bannerInView ? "animate-fade-up" : ""
                    }`}
                    style={{
                        zIndex: 2,
                        textAlign: "center",
                        padding: "20px",
                        width:"100%"
                    }}
                >
                    <Element name="home-banner">
                        <TestimonialCarousel/>
                    </Element>
                </div>
            </div>

            <Element name="home-footer" className="home-footer">
                <Footer/>
            </Element>
        </>
    );
}

export default Home;

